(function () {
  var body = document.body;
  /* encabezado que cambia al hacer scroll */
  function alScroll() { body.classList.toggle('con-scroll', window.scrollY > 90); }
  alScroll(); window.addEventListener('scroll', alScroll, { passive: true });

  /* menú móvil */
  var btn = document.querySelector('[data-menu-btn]'), menu = document.querySelector('[data-menu]');
  if (btn && menu) {
    function cerrar() { menu.hidden = true; btn.setAttribute('aria-expanded', 'false'); body.style.overflow = ''; }
    btn.addEventListener('click', function () {
      var abre = menu.hidden; menu.hidden = !abre;
      btn.setAttribute('aria-expanded', abre ? 'true' : 'false');
      body.style.overflow = abre ? 'hidden' : '';
    });
    menu.addEventListener('click', function (e) { if (e.target.tagName === 'A') cerrar(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });
  }

  /* compartir */
  document.querySelectorAll('[data-compartir]').forEach(function (b) {
    b.addEventListener('click', function () {
      var url = b.dataset.url || location.href, t = b.querySelector('[data-compartir-texto]'), orig = t ? t.textContent : '';
      if (navigator.share) { navigator.share({ title: b.dataset.titulo || document.title, url: url }).catch(function () {}); return; }
      var ok = function () { if (t) { t.textContent = '¡Enlace copiado!'; setTimeout(function () { t.textContent = orig; }, 2200); } };
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(ok, function () { window.prompt('Copia este enlace:', url); });
      else window.prompt('Copia este enlace:', url);
    });
  });

  /* cartas */
  var raiz = document.querySelector('[data-cartas]');
  if (!raiz) return;
  var imgs = raiz.querySelectorAll('[data-carta]');
  var thumbs = raiz.querySelectorAll('[data-thumb]');
  var panel = raiz.querySelector('[data-panel]');
  var info = raiz.querySelector('.carta-info');
  var el = {
    numero: raiz.querySelector('[data-numero]'), num: raiz.querySelector('[data-num]'),
    nombre: raiz.querySelector('[data-nombre]'), ley: raiz.querySelector('[data-leyenda]'),
    cont: raiz.querySelector('[data-contador]')
  };
  var n = imgs.length, i = 0, tmo;
  function ir(k) {
    i = (k + n) % n;
    var t = thumbs[i];
    imgs.forEach(function (im, j) { im.classList.toggle('activa', j === i); });
    thumbs.forEach(function (b, j) {
      b.classList.toggle('activa', j === i);
      b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
    if (panel && t.dataset.panelColor) panel.style.background = t.dataset.panelColor;
    if (el.cont) el.cont.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(n).padStart(2, '0');
    if (info) info.classList.add('cambia');
    clearTimeout(tmo);
    tmo = setTimeout(function () {
      if (el.numero) el.numero.textContent = t.dataset.num;
      if (el.num) el.num.textContent = 'Carta n.º ' + t.dataset.num;
      if (el.nombre) el.nombre.textContent = t.dataset.nombre;
      if (el.ley) el.ley.textContent = t.dataset.leyenda;
      if (info) info.classList.remove('cambia');
    }, 220);
    var tira = thumbs[i].parentNode;
    if (tira && tira.scrollTo) tira.scrollTo({ left: thumbs[i].offsetLeft - tira.clientWidth / 2 + thumbs[i].clientWidth / 2, behavior: 'smooth' });
  }
  thumbs.forEach(function (b, j) { b.addEventListener('click', function () { ir(j); }); });
  var p = raiz.querySelector('[data-prev]'), s = raiz.querySelector('[data-next]');
  if (p) p.addEventListener('click', function () { ir(i - 1); });
  if (s) s.addEventListener('click', function () { ir(i + 1); });
  raiz.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') ir(i - 1);
    if (e.key === 'ArrowRight') ir(i + 1);
  });
  var x0 = null;
  if (panel) {
    panel.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    panel.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) ir(i + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }
})();
